module.exports = __webpack_public_path__ + "static/img/silhouette_07.93ac7ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/silhouettes/thumbnail/silhouette_07.png
// module id = Z3p/
// module chunks = 0